import { useState } from "react";
import { Link } from "react-router";
import {
  LANDING_HEADER_TYPOGRAPHY,
  LANDING_PAGE_GUTTER,
  LANDING_SUPPORT,
  LANDING_ASSETS,
} from "../constants/landing.constants";
import LandingIcon from "./LandingIcon";
import SupportSheet from "./SupportSheet";

export default function LandingHeader() {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-40 bg-white shadow-landing-header">
        <div
          className={`flex h-[80px] items-center justify-between gap-4 ${LANDING_PAGE_GUTTER}`}
        >
          <Link to="/classes" className="shrink-0">
            <img
              src={LANDING_ASSETS.logo}
              alt="Music Temple"
              className="h-[62px] w-[84px] object-contain"
            />
          </Link>

          <div className="hidden md:flex">
            <div className="flex h-[55px] w-[213px] items-center gap-2.5 rounded-[20px] bg-landing-support px-3">
              <LandingIcon name="headset" className="h-[30px] w-[30px] shrink-0" />
              <div className="leading-tight text-landing-support">
                <div className={LANDING_HEADER_TYPOGRAPHY.supportLine1}>
                  Support: {LANDING_SUPPORT.phone}
                </div>
                <div className={LANDING_HEADER_TYPOGRAPHY.supportLine2}>
                  {LANDING_SUPPORT.hours}
                </div>
              </div>
            </div>
          </div>

          <div className="flex md:hidden">
            <button
              type="button"
              className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-100"
              aria-label="Support"
              onClick={() => setSupportOpen(true)}
            >
              <LandingIcon name="headsetMobile" className="h-6 w-6" />
            </button>
          </div>
        </div>
      </header>

      <SupportSheet open={supportOpen} onOpenChange={setSupportOpen} />
    </>
  );
}
